import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private baseUrl = environment.serverUrl + 'customers';
  constructor(private http: HttpClient) { }

  private deviceAdminUrl = environment.serverUrl + 'admin/devices';

  getDeviceOverview(profileId: number | string): Observable<any> {
    return this.http.get(`${this.deviceAdminUrl}/${profileId}`);
  }

  resetDevices(
    profileId: number | string,
    body: { reason: string; startFresh?: boolean; confirmUsername?: string }
  ): Observable<any> {
    return this.http.post(`${this.deviceAdminUrl}/${profileId}/reset`, body);
  }

  login(login: any): Observable<Object> {
    const url = environment.serverUrl;
    return this.http.post(`${url}login/admin`, {
      email: login.Email,
      password: login.Password,
    });
  }

  // Revokes the DB-backed session (sid) and clears the HttpOnly auth cookies server-side.
  logout(): Observable<Object> {
    return this.http.get(`${this.baseUrl}/logout`);
  }

  userList(
    page: number,
    size: number,
    search: string = '',
    startDate,
    endDate
  ): Observable<any> {
    const data = {
      page: page,
      size: size,
      search: search,
      startDate: startDate,
      endDate: endDate,
    };
    return this.http.post(`${this.baseUrl}`, data);
  }

  getUserDetailsById(Id: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/${Id}`);
  }

  changeUserStatus(id, status): Observable<any> {
    const userId = id;
    const IsActive = status;
    return this.http.get(
      `${this.baseUrl}/change-status/${userId}?IsActive=${IsActive}`
    );
  }

  changeAccountType(id, status): Observable<any> {
    const userId = id;
    const type = status;
    return this.http.get(
      `${this.baseUrl}/change-user-type/${userId}?type=${type}`
    );
  }

  suspendUser(id, status): Observable<any> {
    const userId = id;
    const IsSuspended = status;
    return this.http.get(
      `${this.baseUrl}/suspend-user/${userId}?IsSuspended=${IsSuspended}`
    );
  }

  activateMedia(id, status): Observable<any> {
    const userId = id;
    const IsSuspended = status;
    return this.http.get(
      `${this.baseUrl}/activate-media/${userId}?MediaApproved=${IsSuspended}`
    );
  }

  toggleHideFromFeed(profileId: string, hideFromFeed: string): Observable<any> {
    return this.http.put(
      `${environment.serverUrl}admin/users/${profileId}/hide-from-feed`,
      { hideFromFeed }
    );
  }

  getHideFromFeedStatus(profileId: string): Observable<any> {
    return this.http.get(
      `${environment.serverUrl}admin/users/${profileId}/hide-from-feed`
    );
  }

  deleteUser(id): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }

  getUserList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/get`);
  }

  getProfileList(searchText: string = ''): Observable<object> {
    return this.http.get(
      `${this.baseUrl}/search-user?searchText=${searchText}`
    );
  }

  getCountriesData(): Observable<{ country_code: string; country: string }[]> {
    return this.http.get<{ country_code: string; country: string }[]>(
      `${this.baseUrl}/countries`
    );
  }

  getZipData(zip: string, country: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/zip/${zip}?country=${country}`);
  }

  /** Get reward counts for a profile (for payout amount calculation) */
  getPayoutCounts(profileId: string): Observable<any> {
    return this.http.get(`${environment.serverUrl}user-reward-details/getCountByProfileId/${profileId}`);
  }

  /** Admin cashout: send 1776CASH to user's wallet */
  adminCashout(profileId: string, walletAddress: string): Observable<any> {
    return this.http.post(`${environment.serverUrl}admin/cashout`, { profileId, walletAddress });
  }

  updateProfile(id, customer): Observable<Object> {
    return this.http.put(`${this.baseUrl}/profile/${id}`, customer);
  }

  getUserEmailList(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/get-emails`, data);
  }
}
